{
  "actions": {
    "cancel": "Cancelar",
    "save": "Guardar",
    "saving": "Guardando...",
    "update": "Actualizar",
    "create": "Crear"
  },
  "page": {
    "notFound": "Curso no encontrado",
    "editMode": "Modo de edición",
    "viewAsStudent": "Ver como alumno"
  },
  "sectionTypes": {
    "banner": "Banner",
    "module": "Módulos",
    "course": "Cursos",
    "emptySpace": "Espaciado"
  },
  "sidebar": {
    "removeTitle": "Eliminar elemento",
    "removeDescription": "¿Eliminar \"{{title}}\" del menú de este curso?",
    "remove": "Eliminar",
    "edit": "Editar",
    "emptyHint": "Sin elementos propios: los alumnos ven el menú global. Añade elementos para tener un menú exclusivo de este curso.",
    "addItem": "Añadir elemento"
  },
  "chrome": {
    "dragToReorder": "Arrastrar para reordenar",
    "hideFromStudent": "Ocultar al alumno",
    "showToStudent": "Mostrar al alumno",
    "editSection": "Editar sección",
    "removeSection": "Eliminar sección"
  },
  "canvas": {
    "addSection": "Añadir sección",
    "removeDescription": "Esta sección se eliminará de la página del curso.",
    "remove": "Eliminar",
    "emptyTitle": "Página sin secciones",
    "emptyDescription": "Genera el diseño predeterminado (banner + módulos del curso) y personalízalo, o empieza añadiendo secciones manualmente.",
    "generateDefault": "Generar diseño predeterminado"
  },
  "bannerModal": {
    "title": "Editar banner",
    "description": "Elige el tipo de banner y configura su contenido.",
    "variant": "Tipo de banner",
    "variantHero": "Destacado del curso (portada + progreso + botones)",
    "variantCustom": "Personalizado (imagen + título + botón)",
    "heroHint": "Usa la portada, el título y la descripción del curso. Elige qué mostrar:",
    "showCategory": "Mostrar categoría",
    "showProgress": "Mostrar barra de progreso",
    "showStart": "Mostrar botón Empezar/Continuar",
    "showTrail": "Mostrar botón Ver ruta",
    "image": "Imagen",
    "titleLabel": "Título",
    "titlePlaceholder": "Título del banner",
    "subtitle": "Subtítulo",
    "subtitlePlaceholder": "Texto de apoyo (opcional)",
    "ctaSection": "Botón (opcional)",
    "ctaLabel": "Texto del botón",
    "ctaLabelPlaceholder": "Más información",
    "ctaUrl": "Enlace",
    "ctaNewTab": "Abrir en una pestaña nueva"
  },
  "emptySpaceModal": {
    "title": "Editar espaciado",
    "description": "Define la altura del espacio en blanco entre secciones.",
    "height": "Altura",
    "sizes": {
      "sm": "Pequeño",
      "md": "Mediano",
      "lg": "Grande"
    }
  },
  "picker": {
    "sectionTitle": "Título de la sección",
    "dragHint": "Arrastra las tarjetas en la página para reordenarlas.",
    "add": "Añadir",
    "noResults": "Sin resultados"
  },
  "moduleModal": {
    "title": "Editar sección de módulos",
    "description": "Selecciona módulos de cualquier curso. El orden se define arrastrando las tarjetas en la página.",
    "titlePlaceholder": "Módulos",
    "selected": "Módulos seleccionados ({{count}})",
    "noneSelected": "Aún no hay ningún módulo seleccionado.",
    "addLabel": "Añadir módulo",
    "searchPlaceholder": "Buscar módulos...",
    "lessonsCount_one": "{{count}} lección",
    "lessonsCount_zero": "{{count}} lecciones",
    "lessonsCount_other": "{{count}} lecciones",
    "coursesCount_one": "{{count}} curso",
    "coursesCount_zero": "{{count}} cursos",
    "coursesCount_other": "{{count}} cursos",
    "noneAvailable": "No hay módulos disponibles"
  },
  "courseModal": {
    "title": "Editar sección de cursos",
    "description": "Selecciona otros cursos para promocionar en esta sección. El orden se define arrastrando las tarjetas en la página.",
    "titlePlaceholder": "Cursos relacionados",
    "selected": "Cursos seleccionados ({{count}})",
    "noneSelected": "Aún no hay ningún curso seleccionado.",
    "addLabel": "Añadir curso",
    "searchPlaceholder": "Buscar cursos...",
    "noneAvailable": "No hay cursos disponibles"
  },
  "menuItemModal": {
    "title": "Elemento del menú",
    "description": "Configura un elemento de la barra lateral de este curso.",
    "text": "Texto *",
    "textPlaceholder": "Ej.: Comunidad",
    "link": "Enlace",
    "linkPlaceholder": "/community o https://...",
    "icon": "Icono",
    "external": "Enlace externo",
    "newTab": "Abrir en una pestaña nueva"
  },
  "menuItemForm": {
    "titleRequired": "El título es obligatorio",
    "editTitle": "Editar elemento del menú",
    "newTitle": "Nuevo elemento del menú",
    "editDescription": "Actualiza la información del elemento",
    "newDescription": "Añade un nuevo enlace al menú del alumno",
    "titleLabel": "Título *",
    "titlePlaceholder": "Ej.: Comunidad, Soporte, Blog...",
    "icon": "Icono",
    "iconPlaceholder": "Selecciona un icono",
    "linkType": "Tipo de enlace",
    "manualUrl": "URL manual",
    "linkToCourse": "Vincular a un curso",
    "url": "URL",
    "urlExternalPlaceholder": "https://ejemplo.com",
    "urlInternalPlaceholder": "/pagina",
    "selectCourse": "Seleccionar curso",
    "searchCourse": "Buscar curso...",
    "noCourses": "No se encontró ningún curso",
    "external": "Enlace externo",
    "newTab": "Abrir en una pestaña nueva",
    "active": "Elemento activo",
    "create": "Crear elemento",
    "icons": {
      "globe": "Globo (Web)",
      "externalLink": "Enlace externo",
      "chat": "Chat",
      "help": "Ayuda",
      "document": "Documento",
      "video": "Video",
      "music": "Música",
      "image": "Imagen",
      "calendar": "Calendario",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "location": "Ubicación",
      "store": "Tienda",
      "favorite": "Favorito",
      "featured": "Destacado",
      "quickAction": "Acción rápida",
      "course": "Curso",
      "community": "Comunidad",
      "gift": "Regalo",
      "announcement": "Anuncio"
    }
  },
  "bannerForm": {
    "imageRequired": "La imagen es obligatoria",
    "editTitle": "Editar banner",
    "newTitle": "Nuevo banner",
    "editDescription": "Actualiza la información del banner",
    "newDescription": "Añade un nuevo banner a la plataforma",
    "image": "Imagen del banner *",
    "titleLabel": "Título (opcional)",
    "titlePlaceholder": "Ej.: Promoción de verano",
    "linkLabel": "Enlace de destino (opcional)",
    "linkPlaceholder": "Ej.: /courses o https://...",
    "position": "Posición",
    "positions": {
      "home": "Inicio (Panel)",
      "sidebar": "Barra lateral",
      "header": "Cabecera (Superior)"
    },
    "active": "Banner activo",
    "create": "Crear banner"
  },
  "sectionForm": {
    "titleMin": "El título debe tener al menos 3 caracteres",
    "updateSuccess": "Sección actualizada correctamente",
    "createSuccess": "Sección creada correctamente",
    "saveError": "Error al guardar la sección",
    "editTitle": "Editar sección",
    "newTitle": "Nueva sección",
    "description": "Configura los datos de la sección",
    "titleLabel": "Título *",
    "titlePlaceholder": "Ej.: FASE 01 - La llamada de la Fuerza",
    "descriptionLabel": "Descripción",
    "descriptionPlaceholder": "Descripción de la sección (opcional)",
    "backgroundColor": "Color de fondo",
    "backgroundColorHint": "Color de fondo personalizado para esta sección (opcional)",
    "visible": "Visible",
    "visibleHint": "Mostrar esta sección a los alumnos"
  },
  "sectionManagement": {
    "deleteTitle": "Eliminar sección",
    "deleteDescription": "¿Eliminar esta sección? Los productos no se eliminarán.",
    "delete": "Eliminar",
    "deleteSuccess": "Sección eliminada correctamente",
    "deleteError": "Error al eliminar la sección",
    "hiddenSuccess": "Sección ocultada",
    "visibleSuccess": "Sección visible",
    "visibilityError": "Error al actualizar la visibilidad",
    "title": "Secciones de cursos",
    "subtitle": "Organiza los cursos en secciones horizontales estilo Netflix/Xtreed",
    "newSection": "Nueva sección",
    "hidden": "Oculta",
    "productsCount_one": "{{count}} producto",
    "productsCount_zero": "{{count}} productos",
    "productsCount_other": "{{count}} productos",
    "hide": "Ocultar",
    "show": "Mostrar",
    "emptyTitle": "No hay secciones creadas",
    "emptyDescription": "Crea secciones para organizar los cursos (p. ej.: FASE 01, FASE 02)",
    "createFirst": "Crear primera sección"
  },
  "toasts": {
    "createMenuItemError": "Error al crear el elemento del menú",
    "createSectionError": "Error al crear la sección",
    "deleteMenuItemError": "Error al eliminar el elemento del menú",
    "deleteSectionError": "Error al eliminar la sección",
    "reorderMenuError": "Error al reordenar el menú",
    "reorderSectionsError": "Error al reordenar las secciones",
    "updateMenuItemError": "Error al actualizar el elemento del menú",
    "updateSectionError": "Error al actualizar la sección"
  }
}
